import api from './api'

const IdpDataProvider = {
  Login(user) {
    return api.post('Idp/Account/Login', user)
  },
  passwordLess(data) {
    return api.post('Idp/Account/Login/PasswordLess', data)
  },
  sendVerifyToken(code) {
    return api.post('Idp/Account/SendVerfyToken', code)
  },
  changePassword(password) {
    return api.post('Idp/UserRegistration/ChangePassword', password)
  },
  getUserProfile() {
    return api.get('Idp/Profile')
  },
  getPagePermisions(params = {}) {
    return api.query('Aggregator.Crm/api/Table/InitialPage', { params })
  },
  generateCaptcha() {
    return api.get('Idp/Account/GenerateCaptcha')
  },
}

export default IdpDataProvider
